import taxDisplayConfigs from '../../../../taxDisplays/taxDisplays.json';
import { trackUnknownTaxDisplayModeError } from '../../../apis/newRelicTrackingApi';

export const EU_VAT_STYLE = 'euVatStyle';
export const US_SALES_TAX_STYLE = 'usSalesTaxStyle';
export const CA_TAX_DISPLAY_MODE = 'caSalesTaxStyle';
export const GST_TAX_DISPLAY_MODE = 'globalGstTaxStyle';
export const IN_TAX_DISPLAY_MODE = 'inSalesTaxStyle';

export const availableTaxDisplayModes = [
  US_SALES_TAX_STYLE,
  EU_VAT_STYLE,
  CA_TAX_DISPLAY_MODE,
  GST_TAX_DISPLAY_MODE,
  IN_TAX_DISPLAY_MODE,
];

export function getTaxConfiguration(taxDisplayStyle) {
  if (!taxDisplayConfigs) {
    console.error(
      'An error occurred finding all possible tax display configs!'
    );
  }
  const taxConfig = taxDisplayConfigs.find(
    config => config.taxDisplayMode === taxDisplayStyle
  );
  if (!taxConfig) {
    trackUnknownTaxDisplayModeError(taxDisplayStyle);
    console.error(
      `Could not find a taxDisplayConfig for this order and taxDisplayMode:${taxDisplayStyle}`
    );
  }
  return taxConfig;
}
